import { toast } from "react-toastify";

export const base = {
  // imageUrl: "https://staging.isit.services/storage/",
  imageUrl: "http://127.0.0.1:8000/storage/",
};

export const services = [
  { value: 1, label: "Accounting" },
  { value: 2, label: "Accounting Services" },
  { value: 3, label: "Accounting Education" },
  { value: 4, label: "Accounting Information System" },
  { value: 5, label: "Actor/ Actress" },
  { value: 6, label: "Acupuncturist" },
  { value: 7, label: "Ad Agency" },
  { value: 8, label: "ADHC Adult day Care Center" },
  { value: 9, label: "Adjuster (Insurance)" },
  { value: 10, label: "Administrative services" },
  { value: 11, label: "Administrator" },
  { value: 12, label: "Adoption services/ Agency" },
  { value: 13, label: "Adult daycare centers" },
  { value: 14, label: "Adult Exercising/ Walking Services" },
  { value: 15, label: "Adult Medical Care" },
  { value: 16, label: "Adult Social Care" },
  { value: 17, label: "Advertising Agency" },
  { value: 18, label: "Agent (Insurance)" },
  { value: 19, label: "Agent (Talent)" },
  { value: 20, label: "Agent (Travel)" },
  { value: 21, label: "Agricultural services" },
  { value: 22, label: "Air conditioning service" },
  { value: 23, label: "Air duct Cleaner" },
  { value: 24, label: "Airport Limo services" },
  { value: 25, label: "Airport Taxi" },
  { value: 26, label: "Airport Transportation" },
  { value: 27, label: "Alterations" },
  { value: 28, label: "Ambulance services" },
  { value: 29, label: "Amish Taxi" },
  { value: 30, label: "Amusement Park services" },
  { value: 31, label: "Animal Aquaculture" },
  { value: 32, label: "Animal Cemetery" },
  { value: 33, label: "Animal Hospital" },
  { value: 34, label: "Animal removal" },
  { value: 35, label: "Animal shelter" },
  { value: 36, label: "Answering service" },
  { value: 37, label: "Antique dealer/ Shop" },
  { value: 38, label: "Apartment Builder" },
  { value: 39, label: "Apartment building Management" },
  { value: 40, label: "Apparel manufacturer" },
  { value: 41, label: "Apparel retailer/ store" },
  { value: 42, label: "Apparel wholesaler" },
  { value: 43, label: "Appliance Rental" },
  { value: 44, label: "Appliance Repair" },
  { value: 45, label: "Appliance sales/ dealer" },
  { value: 46, label: "Appraisal" },
  { value: 47, label: "Aquaculture" },
  { value: 48, label: "Arborist" },
  { value: 49, label: "Architect" },
  { value: 50, label: "Architectural services" },
  { value: 51, label: "Armored car services" },
  { value: 52, label: "Aromatherapy" },
  { value: 53, label: "Art gallery/ dealer" },
  { value: 54, label: "Art Restoration" },
  { value: 55, label: "Artist" },
  { value: 56, label: "Art Sales" },
  { value: 57, label: "Asphalt Hauling" },
  { value: 58, label: "Asphalt Laying/ Repair" },
  { value: 59, label: "Assisted Living Facility services" },
  { value: 60, label: "Athlete" },
  { value: 61, label: "Athletic services" },
  { value: 62, label: "ATV" },
  { value: 63, label: "Auction Hauler" },
  { value: 64, label: "Auctioneer" },
  { value: 65, label: "Audio visual Engineer" },
  { value: 66, label: "Audio Visual Rental & Leasing" },
  { value: 67, label: "Auditing & Assurance" },
  { value: 68, label: "Auditor" },
  { value: 69, label: "Author" },
  { value: 70, label: "Auto Body Shop" },
  { value: 71, label: "Auto dealer Services" },
  { value: 72, label: "Auto Detailer" },
  { value: 73, label: "Auto Glass Replacement" },
  { value: 74, label: "Auto Hauler" },
  { value: 75, label: "Auto Hauler for hire Trucking" },
  { value: 76, label: "Auto Painter" },
  { value: 77, label: "Auto parts dealer" },
  { value: 78, label: "Auto renter" },
  { value: 79, label: "Auto Mechanic" },
  { value: 80, label: "Auto Salvage Hauler" },
  { value: 81, label: "Aviation School Teacher" },
  { value: 82, label: "Aviator" },
  { value: 83, label: "Avon sales" },
  { value: 84, label: "Awning Installer/ repair" },
  { value: 85, label: "B&B Bed & Breakfast services" },
  { value: 86, label: "Baby sitting services" },
  { value: 87, label: "Baby Supply Service" },
  { value: 88, label: "Backhoe Services" },
  { value: 89, label: "Bagel Shop services" },
  { value: 90, label: "Bail Bonds" },
  { value: 91, label: "Baker" },
  { value: 92, label: "Bakery" },
  { value: 93, label: "Ballet Institution" },
  { value: 94, label: "Balloon Rvaluee Operator" },
  { value: 95, label: "Band" },
  { value: 96, label: "Banking services" },
  { value: 97, label: "Bankruptcy Services" },
  { value: 98, label: "Banquet Catering" },
  { value: 99, label: "Banquet Hall" },
  { value: 100, label: "Bar" },
  { value: 101, label: "Barber" },
  { value: 102, label: "Barber school" },
  { value: 103, label: "Barber shop" },
  { value: 104, label: "Barn Builder" },
  { value: 105, label: "Bartender" },
  { value: 106, label: "Bartending School" },
  { value: 107, label: "Bathroom Remodeling" },
  { value: 108, label: "Beautician" },
  { value: 109, label: "Beauty" },
  { value: 110, label: "Beauty Salon" },
  { value: 111, label: "Beauty supply Store" },
  { value: 112, label: "Beer Distributor" },
  { value: 113, label: "Belly Dancer" },
  { value: 114, label: "Beverage Distributor" },
  { value: 115, label: "Bicycle Repair" },
  { value: 116, label: "Bicycle shop" },
  { value: 117, label: "Billboard (Mobile)" },
  { value: 118, label: "Billiard" },
  { value: 119, label: "Bingo Transportation" },
  { value: 120, label: "Black car" },
  { value: 121, label: "Boarding House/ School" },
  { value: 122, label: "Boarding Stable" },
  { value: 123, label: "Boat charter" },
  { value: 124, label: "Boat engine repair" },
  { value: 125, label: "Boat maintenance" },
  { value: 126, label: "Boat Sales" },
  { value: 127, label: "Boat storage" },
  { value: 128, label: "Body Piercing" },
  { value: 129, label: "Body Shop" },
  { value: 130, label: "Bodyguard" },
  { value: 131, label: "Boiler Repair" },
  { value: 132, label: "Book Binder" },
  { value: 133, label: "Book Publisher" },
  { value: 134, label: "Book Store/ Dealer" },
  { value: 135, label: "Bookkeeper" },
  { value: 136, label: "Botanical" },
  { value: 137, label: "Bottler/ Bottling Operations" },
  { value: 138, label: "Boutique" },
  { value: 139, label: "Bowling Alley" },
  { value: 140, label: "Break Repair" },
  { value: 141, label: "Brick Contractor" },
  { value: 142, label: "Brick Layer" },
  { value: 143, label: "Brvalueal Shop" },
  { value: 144, label: "Brvaluege Builder" },
  { value: 145, label: "Broadcasting Station" },
  { value: 146, label: "Broker (Bond/ Securities)" },
  { value: 147, label: "Broker (Insurance)" },
  { value: 148, label: "Broker (Investment)" },
  { value: 149, label: "Broker (Real Estate)" },
  { value: 150, label: "Builder (commercial)" },
  { value: 151, label: "Builder (resvalueential)" },
  { value: 152, label: "Building (Road/ Utilities)" },
  { value: 153, label: "Building Cleaning" },
  { value: 154, label: "Building Equipment Installation" },
  { value: 155, label: "Building Inspection" },
  { value: 156, label: "Building Maintenance" },
  { value: 157, label: "Building Manager" },
  { value: 158, label: "Building Material Supply" },
  { value: 159, label: "Building Owner" },
  { value: 160, label: "Bulk Water Hauler" },
  { value: 161, label: "Burglar alarm Installer" },
  { value: 162, label: "Business consultant/ Analyst" },
  { value: 163, label: "Business school" },
  { value: 164, label: "Business Services" },
  { value: 165, label: "Butcher" },
  { value: 166, label: "Butcher Shop" },
  { value: 167, label: "Cabinet Installer" },
  { value: 168, label: "Cabinet Maker" },
  { value: 169, label: "Cable Television" },
  { value: 170, label: "Cable Tv Installer" },
  { value: 171, label: "Café/ Cafeteria" },
  { value: 172, label: "Cake Maker" },
  { value: 173, label: "Calligrapher" },
  { value: 174, label: "Camera Store" },
  { value: 175, label: "Campaign Office" },
  { value: 176, label: "Camper repair" },
  { value: 177, label: "Camper Sales" },
  { value: 178, label: "Campgrounds" },
  { value: 179, label: "Candy Distributor" },
  { value: 180, label: "Candy Store" },
  { value: 181, label: "Cannery" },
  { value: 182, label: "Canoe Retail/ Tour" },
  { value: 183, label: "Car dealer/ Sales" },
  { value: 184, label: "Car Hauler" },
  { value: 185, label: "Car manufacturer" },
  { value: 186, label: "Car polishing" },
  { value: 187, label: "Car rental Companies" },
  { value: 188, label: "Car Washer" },
  { value: 189, label: "Card store" },
  { value: 190, label: "Care Center Adult" },
  { value: 191, label: "Care Center Child" },
  { value: 192, label: "Career Counselling" },
  { value: 193, label: "Cargo Transport" },
  { value: 194, label: "Carnival Food Stand" },
  { value: 195, label: "Carnival ride" },
  { value: 196, label: "Carpenter" },
  { value: 197, label: "Carpet cleaning" },
  { value: 198, label: "Carpet Installer" },
  { value: 199, label: "Carpet Manufacturer" },
  { value: 200, label: "Carpet Sales" },
  { value: 201, label: "Carriers" },
  { value: 202, label: "Carry out" },
  { value: 203, label: "Cartage" },
  { value: 204, label: "Casino" },
  { value: 205, label: "Casino Operator" },
  { value: 206, label: "Casket" },
  { value: 207, label: "Cat Grooming" },
  { value: 208, label: "Caterer" },
  { value: 209, label: "Caulking Contractor" },
  { value: 210, label: "Ceiling Cleaning" },
  { value: 211, label: "Cellular services" },
  { value: 212, label: "Cellular Store" },
  { value: 213, label: "Cement Contractor" },
  { value: 214, label: "Cement Finishing/ Repair" },
  { value: 215, label: "Cemetery" },
  { value: 216, label: "Chair & Table rental" },
  { value: 217, label: "Charitable" },
  { value: 218, label: "Charter Bus" },
  { value: 219, label: "Check Cashing" },
  { value: 220, label: "Chemical Manufacturer" },
  { value: 221, label: "Chemist" },
  { value: 222, label: "Chicken Catcher" },
  { value: 223, label: "Child adoption" },
  { value: 224, label: "Child Care" },
  { value: 225, label: "Child Psychologist" },
  { value: 226, label: "Children’s Camp" },
  { value: 227, label: "Children clothing store" },
  { value: 228, label: "Chimney Builder & Repair" },
  { value: 229, label: "Chimney Sweep" },
  { value: 230, label: "Chinese restaurant" },
  { value: 231, label: "Chiropractor" },
  { value: 232, label: "Choir" },
  { value: 233, label: "Church" },
  { value: 234, label: "Circus" },
  { value: 235, label: "Civic" },
  { value: 236, label: "Civic Organization" },
  { value: 237, label: "Civil Engineer" },
  { value: 238, label: "Cleaner (Carpet)" },
  { value: 239, label: "Cleaner Dry Cleaning/ Laundry" },
  { value: 240, label: "Cleaning Services" },
  { value: 241, label: "Cleaning Airduct" },
  { value: 242, label: "Clearing Land" },
  { value: 243, label: "Clergy" },
  { value: 244, label: "Clothing Manufacturing" },
  { value: 245, label: "Clothing Store" },
  { value: 246, label: "Clown" },
  { value: 247, label: "Clubs" },
  { value: 248, label: "Club (Dancer)" },
  { value: 249, label: "Coach" },
  { value: 250, label: "Coal Hauling" },
  { value: 251, label: "Cocktail lounge" },
  { value: 252, label: "Coffee shop" },
  { value: 253, label: "Coffee truck" },
  { value: 254, label: "Coin Dealer" },
  { value: 255, label: "Coin Operator" },
  { value: 256, label: "Coin operated laundry" },
  { value: 257, label: "Collectibles store" },
  { value: 258, label: "Collection agency" },
  { value: 259, label: "College" },
  { value: 260, label: "Collision repair shop" },
  { value: 261, label: "Comedy Club" },
  { value: 262, label: "Comic bookstore" },
  { value: 263, label: "Commercial photographer" },
  { value: 264, label: "Commercial trucker" },
  { value: 265, label: "Commodity broker" },
  { value: 266, label: "Common carrier" },
  { value: 267, label: "Computer consultant/ Programmer" },
  { value: 268, label: "Computer dating service" },
  { value: 269, label: "Computer Manufacturer" },
  { value: 270, label: "Computer repair service" },
  { value: 271, label: "Computer sales" },
  { value: 272, label: "Computer Training" },
  { value: 273, label: "Concession Stand" },
  { value: 274, label: "Concrete finishing/ Repair" },
  { value: 275, label: "Confectionery" },
  { value: 276, label: "Consignment Shop" },
  { value: 277, label: "Construction (Commercial)" },
  { value: 278, label: "Construction (residential)" },
  { value: 279, label: "Construction (Road/ Highways/ Utilities)" },
  { value: 280, label: "Consultant" },
  { value: 281, label: "Consulting Energy Industry" },
  { value: 282, label: "Consulting Oil & Gas" },
  { value: 283, label: "Container Hauling" },
  { value: 284, label: "Contaminated Dirt" },
  { value: 285, label: "Contract carrier/ Trucking" },
  { value: 286, label: "Contractor" },
  { value: 287, label: "Convenience Store" },
  { value: 288, label: "Covent" },
  { value: 289, label: "Cooking School" },
  { value: 290, label: "Copy machine Repair" },
  { value: 291, label: "Copying Services" },
  { value: 292, label: "Corporate Accounting" },
  { value: 293, label: "Correctional Institution" },
  { value: 294, label: "Cosmetic Surgeon" },
  { value: 295, label: "Cosmetologist" },
  { value: 296, label: "Counseling Services" },
  { value: 297, label: "Counselor" },
  { value: 298, label: "Country Club" },
  { value: 299, label: "Courier (Local)" },
  { value: 300, label: "Courier (International)" },
  { value: 301, label: "Court House" },
  { value: 302, label: "CPA" },
  { value: 303, label: "Craft Supply Store" },
  { value: 304, label: "Crafters" },
  { value: 305, label: "Credit Counseling Services" },
  { value: 306, label: "Credit Reporting Agency" },
  { value: 307, label: "Credit Union/ Agency" },
  { value: 308, label: "Cremation Services" },
  { value: 309, label: "Crime Scene Clean Up" },
  { value: 310, label: "Crisis Center" },
  { value: 311, label: "Crop" },
  { value: 312, label: "Custodial Work" },
  { value: 313, label: "Custom Harvester" },
  { value: 314, label: "Dairy Farmer" },
  { value: 315, label: "Dairy Products Hauling" },
  { value: 316, label: "Dance Company" },
  { value: 317, label: "Dance Instructor" },
  { value: 318, label: "Dance Studio" },
  { value: 319, label: "Data Processor" },
  { value: 320, label: "Dating Services" },
  { value: 321, label: "Day Camps" },
  { value: 322, label: "Dealer (Auto/Truck)" },
  { value: 323, label: "Dealer (Other)" },
  { value: 324, label: "Debris Removal" },
  { value: 325, label: "Debt Counseling Service" },
  { value: 326, label: "Deck Builder" },
  { value: 327, label: "Deck Cleaning" },
  { value: 328, label: "Deli" },
  { value: 329, label: "Deli (Restaurant)" },
  { value: 330, label: "Delivery Service (Food)" },
  { value: 331, label: "Delivery Service (Local, Parcels)" },
  { value: 332, label: "Delivery Service (LTL, Freight)" },
  { value: 333, label: "Demolition Contractor" },
  { value: 334, label: "Dental Assistance" },
  { value: 335, label: "Dental Lab" },
  { value: 336, label: "Dentist" },
  { value: 337, label: "Department Store" },
  { value: 338, label: "Desktop Publishing" },
  { value: 339, label: "Detailer" },
  { value: 340, label: "Detective Agency" },
  { value: 341, label: "Developer (Commercial)" },
  { value: 342, label: "Developer (Residential)" },
  { value: 343, label: "Developer (Roads/ Highways)" },
  { value: 344, label: "Dialysis Center" },
  { value: 345, label: "Diaper Service" },
  { value: 346, label: "Die Maker" },
  { value: 347, label: "Dietician" },
  { value: 348, label: "Diner" },
  { value: 349, label: "Dinner Theater" },
  { value: 350, label: "Direct Mail Advertiser" },
  { value: 351, label: "Dirt Hauling" },
  { value: 352, label: "Dirt Sand & Gravel" },
  { value: 353, label: "Dirty Dirt" },
  { value: 354, label: "Disabled Person Transportation" },
  { value: 355, label: "Disc Jockey" },
  { value: 356, label: "Discount Store" },
  { value: 357, label: "Disinfecting Services" },
  { value: 358, label: "Distributor (Food/ Snack)" },
  { value: 359, label: "Distributor (Pallet)" },
  { value: 360, label: "Diving Instructor" },
  { value: 361, label: "DJ" },
  { value: 362, label: "Doctor" },
  { value: 363, label: "Document Imaging" },
  { value: 364, label: "Dog Daycare" },
  { value: 365, label: "Dog Groomer" },
  { value: 366, label: "Dog Obedience School" },
  { value: 367, label: "Dog Pound" },
  { value: 368, label: "Dog Sitter" },
  { value: 369, label: "Dog Walker" },
  { value: 370, label: "Dollar Store" },
  { value: 371, label: "Donut Shop" },
  { value: 372, label: "Door to Door (Sales)" },
  { value: 373, label: "Dozer Services" },
  { value: 374, label: "Drapery Cleaner" },
  { value: 375, label: "Drapery Store" },
  { value: 376, label: "Dress Maker" },
  { value: 377, label: "Drilling (Oil Well)" },
  { value: 378, label: "Drilling (Water Well)" },
  { value: 379, label: "Drive Through Services" },
  { value: 380, label: "Drive Up Restaurant" },
  { value: 381, label: "Drive In Theater" },
  { value: 382, label: "Driveway Laying/ Repair" },
  { value: 383, label: "Driving Instructor" },
  { value: 384, label: "Driving Range" },
  { value: 385, label: "Driving School" },
  { value: 386, label: "Drug Company" },
  { value: 387, label: "Drug Store" },
  { value: 388, label: "Dry Cleaning" },
  { value: 389, label: "Drywall Contractor" },
  { value: 390, label: "Drywall Repair" },
  { value: 391, label: "Duct Cleaner" },
  { value: 392, label: "Dump Truck Driver" },
  { value: 393, label: "Eatery" },
  { value: 394, label: "Educational Consultant" },
  { value: 395, label: "Electrical Contractor" },
  { value: 396, label: "Electrical Repair" },
  { value: 397, label: "Electrician" },
  { value: 398, label: "Electrolysis" },
  { value: 399, label: "Electronics Manufacturing" },
  { value: 400, label: "Electronics Repair" },
  { value: 401, label: "Electronics Store" },
  { value: 402, label: "Elevated Highway" },
  { value: 403, label: "Emergency Care" },
  { value: 404, label: "Emissions Testing Facility" },
  { value: 405, label: "Employment Agency" },
  { value: 406, label: "EMS Ambulance" },
  { value: 407, label: "Engine Repair (Auto)" },
  { value: 408, label: "Engineer" },
  { value: 409, label: "Engineer (Energy)" },
  { value: 410, label: "Engineer (Oil & Gas)" },
  { value: 411, label: "Engineering Services" },
  { value: 412, label: "Engraver" },
  { value: 413, label: "Entertainer" },
  { value: 414, label: "Entertainment Supply Rental" },
  { value: 415, label: "Entomologist" },
  { value: 416, label: "Environmental Services" },
  { value: 417, label: "Equipment Leasing/ Rental" },
  { value: 418, label: "Equipment Repair" },
  { value: 419, label: "Escort Vehicle" },
  { value: 420, label: "Estate Planner" },
  { value: 421, label: "Event Limo" },
  { value: 422, label: "Event Planner" },
  { value: 423, label: "Excavator" },
  { value: 424, label: "Executive Consultant" },
  { value: 425, label: "Exercise Equipment Installation" },
  { value: 426, label: "Exercise Equipment Sales" },
  { value: 427, label: "Expediter" },
  { value: 428, label: "Exporter" },
  { value: 429, label: "Exterminator" },
  { value: 430, label: "Eye Doctor" },
  { value: 431, label: "Fabric Sales" },
  { value: 432, label: "Fabricator" },
  { value: 433, label: "Family Care" },
  { value: 434, label: "Family Counselor" },
  { value: 435, label: "Farm Equipment Wholesaler" },
  { value: 436, label: "Farm Produce/ Production Hauling" },
  { value: 437, label: "Farming" },
  { value: 438, label: "Fashion Designer/ Consultant" },
  { value: 439, label: "Fast Food Restaurant" },
  { value: 440, label: "Fax Services" },
  { value: 441, label: "Fence Installation / Repair" },
  { value: 442, label: "Fencing Instructor (Sport)" },
  { value: 443, label: "Film Developing" },
  { value: 444, label: "Financial Advisor/ Planner" },
  { value: 445, label: "Financial Services" },
  { value: 446, label: "Fingerprinting Services" },
  { value: 447, label: "Fire Alarm Installation" },
  { value: 448, label: "Fire Extinguisher Inspector" },
  { value: 449, label: "Fire Extinguisher Sales" },
  { value: 450, label: "Firewood Delivery" },
  { value: 451, label: "Fish Market" },
  { value: 452, label: "Fishery" },
  { value: 453, label: "Fishing Charter" },
  { value: 454, label: "Fitness Center" },
  { value: 455, label: "Flea Market" },
  { value: 456, label: "Flight School" },
  { value: 457, label: "Floor Cleaning/ Polishing" },
  { value: 458, label: "Floor Installation/ Refinishing" },
  { value: 459, label: "Floral Design" },
  { value: 460, label: "Floriculture Production" },
  { value: 461, label: "Florist" },
  { value: 462, label: "Flower Wholesaler" },
  { value: 463, label: "Food Assistance Program" },
  { value: 464, label: "Food Delivery" },
  { value: 465, label: "Food Distributor" },
  { value: 466, label: "Food Manufacturing/ Refinery" },
  { value: 467, label: "Food Mart" },
  { value: 468, label: "Food Taxi" },
  { value: 469, label: "Food Truck" },
  { value: 470, label: "For Hire Truck" },
  { value: 471, label: "For Hire Trucking" },
  { value: 472, label: "Forestry Services" },
  { value: 473, label: "Formal Wear Rental" },
  { value: 474, label: "Foster Care Agency" },
  { value: 475, label: "Foundation Work" },
  { value: 476, label: "Fracking Sand Hauling" },
  { value: 477, label: "Fracking Water (Fresh or Production) Hauling" },
  { value: 478, label: "Framing Contractor" },
  { value: 479, label: "Fraternal Organization" },
  { value: 480, label: "Freight Forwarder" },
  { value: 481, label: "Frozen Food Manufacturing" },
  { value: 482, label: "Frozen Foods Hauling" },
  { value: 483, label: "Frozen Food Wholesaler" },
  { value: 484, label: "Fruit Stand" },
  { value: 485, label: "Fumigating Services" },
  { value: 486, label: "Funeral Director" },
  { value: 487, label: "Funeral Home" },
  { value: 488, label: "Furnace Installer/ Repair" },
  { value: 489, label: "Furniture Cleaning (Upholstered)" },
  { value: 490, label: "Furniture Maker" },
  { value: 491, label: "Furniture Mover" },
  { value: 492, label: "Furniture Rental" },
  { value: 493, label: "Furniture Repair" },
  { value: 494, label: "Furniture Store" },
  { value: 495, label: "Furniture Wholesaler" },
  { value: 496, label: "Gambling Casino" },
  { value: 497, label: "Game Parlor" },
  { value: 498, label: "Game Preserve" },
  { value: 499, label: "Gaming Center" },
  { value: 500, label: "Garage Builder" },
  { value: 501, label: "Garbage & Trash Hauling/ Removal" },
  { value: 502, label: "Garden Center" },
  { value: 503, label: "Garden Equipment Wholesaler" },
  { value: 504, label: "Gardener" },
  { value: 505, label: "Garment Pressing" },
  { value: 506, label: "Gas Station" },
  { value: 507, label: "General Automotive Repair" },
  { value: 508, label: "General Contractor (Commercial)" },
  { value: 509, label: "General Contractor (Residential)" },
  { value: 510, label: "General Contractor (Roads/ Highways)" },
  { value: 511, label: "General Freight Hauler" },
  { value: 512, label: "General Maintenance" },
  { value: 513, label: "Geologist" },
  { value: 514, label: "Geriatric Care Management" },
  { value: 515, label: "Gift Shop" },
  { value: 516, label: "Glass Block Installation" },
  { value: 517, label: "Glass Blower" },
  { value: 518, label: "Glass Installation/ Repair" },
  { value: 519, label: "Glass Replacement Automotive" },
  { value: 520, label: "Glazer (Glass)" },
  { value: 521, label: "Go Kart Facility" },
  { value: 522, label: "Golf Course" },
  { value: 523, label: "Golf Instructor" },
  { value: 524, label: "Gospel Group/ Singer" },
  { value: 525, label: "Gourmet Shop" },
  { value: 526, label: "Government Agency/ Offices" },
  { value: 527, label: "Grading Land" },
  { value: 528, label: "Grain Refinery" },
  { value: 529, label: "Granite Work" },
  { value: 530, label: "Graphic Designer" },
  { value: 531, label: "Gravel Hauling" },
  { value: 532, label: "Gravel Pit" },
  { value: 533, label: "Greenhouse" },
  { value: 534, label: "Greeting Card Manufacturing" },
  { value: 535, label: "Greeting Card Store" },
  { value: 536, label: "Grocery Store (Retail)" },
  { value: 537, label: "Grocery Wholesaler" },
  { value: 538, label: "Groomer (Pet)" },
  { value: 539, label: "Ground To Air Transferring" },
  { value: 540, label: "Guard Services" },
  { value: 541, label: "Guided Tours" },
  { value: 542, label: "Gun Range" },
  { value: 543, label: "Gunsmith" },
  { value: 544, label: "Gutter Installation/ Repair" },
  { value: 545, label: "Gym Installation/ Repair" },
  { value: 546, label: "Gym/ Gymnasium" },
  { value: 547, label: "Gymnastic Instructor" },
  { value: 548, label: "Hair Dresser" },
  { value: 549, label: "Hair Removal (Permanent)" },
  { value: 550, label: "Hair Removal (Waxing)" },
  { value: 551, label: "Hair Replacement" },
  { value: 552, label: "Hair Salon" },
  { value: 553, label: "Hair Stylist/ Design" },
  { value: 554, label: "Halls (Party/ Reception)" },
  { value: 555, label: "Handyman" },
  { value: 556, label: "Hardware Store" },
  { value: 557, label: "Hardwood Flooring Installation/ Refinishing" },
  { value: 558, label: "Harvesting Crop" },
  { value: 559, label: "Hauling" },
  { value: 560, label: "Hayride Tour" },
  { value: 561, label: "Hazardous Materials Hauling" },
  { value: 562, label: "Head Start Center" },
  { value: 563, label: "Health Club" },
  { value: 564, label: "Health Food Store" },
  { value: 565, label: "Health Practitioner" },
  { value: 566, label: "Heating & Air Contractor" },
  { value: 567, label: "Heating & Air Services" },
  { value: 568, label: "Heavy Construction" },
  { value: 569, label: "Heavy Equipment Mechanic" },
  { value: 570, label: "Highway Construction" },
  { value: 571, label: "Hobby Shop" },
  { value: 572, label: "Holding Shop" },
  { value: 573, label: "Holding Company" },
  { value: 574, label: "Home & Garden Store" },
  { value: 575, label: "Home (Elderly/ Nursing)" },
  { value: 576, label: "Home Appliance Rental" },
  { value: 577, label: "Home Builder" },
  { value: 578, label: "Home Furnishing Store" },
  { value: 579, label: "Home Healthcare" },
  { value: 580, label: "Home Improvement Contractor" },
  { value: 581, label: "Home Improvement Store" },
  { value: 582, label: "Home Inspection Services" },
  { value: 583, label: "Home Renovations" },
  { value: 584, label: "Home Security Installation" },
  { value: 585, label: "Home/ Office Water Delivery" },
  { value: 586, label: "Horse Training" },
  { value: 587, label: "Horseback Riding Stable" },
  { value: 588, label: "Horticulturalist" },
  { value: 589, label: "Hospice" },
  { value: 590, label: "Hospital (Animal)" },
  { value: 591, label: "Hospital (Medical & Mental Health)" },
  { value: 592, label: "Hot Air Balloon Ride" },
  { value: 593, label: "Hot Dog Stand" },
  { value: 594, label: "Hot Tub Dealer" },
  { value: 595, label: "Hot Tub Rental" },
  { value: 596, label: "Hotel (Shuttle Service)" },
  { value: 597, label: "Hotel Shuttle" },
  { value: 598, label: "Hotshot (Auto Haulers)" },
  { value: 599, label: "House Cleaning" },
  { value: 600, label: "House Leveling" },
  { value: 601, label: "House Painting" },
  { value: 602, label: "Household Goods Manufacturing" },
  { value: 603, label: "Household Goods Mover" },
  { value: 604, label: "Household Goods Rental & Leasing" },
  { value: 605, label: "Housekeeper" },
  { value: 606, label: "Housing Contractor / Developer" },
  { value: 607, label: "Housing Program" },
  { value: 608, label: "Humane Society" },
  { value: 609, label: "Hunter" },
  { value: 610, label: "HVAC Technician" },
  { value: 611, label: "Hypnotist (Entertainment)" },
  { value: 612, label: "Hypnotist (Medical)" },
  { value: 613, label: "Ice Cream Cart" },
  { value: 614, label: "Ice Cream Hauling" },
  { value: 615, label: "Ice Cream Sales" },
  { value: 616, label: "Ice Cream Stand/ Store/ Parlor" },
  { value: 617, label: "Ice Cream Vendor" },
  { value: 618, label: "Ice Manufacturing" },
  { value: 619, label: "Ice Skating Rink" },
  { value: 620, label: "Imported Food Store" },
  { value: 621, label: "Janitor" },
  { value: 622, label: "Jewelry Appraiser" },
  { value: 623, label: "Jewelry Repair" },
  { value: 624, label: "Jewelry Store/ Jeweler" },
  { value: 625, label: "Job training services" },
  { value: 626, label: "Juggler" },
  { value: 627, label: "Junk Yard" },
  { value: 628, label: "Karaoke Services/ DJ" },
  { value: 629, label: "Kennel" },
  { value: 630, label: "Kiddie Park" },
  { value: 631, label: "Kids Camp" },
  { value: 632, label: "Kitchen Remodeling" },
  { value: 633, label: "Labor Organization / Union" },
  { value: 634, label: "Laboratory (Non Medical)" },
  { value: 635, label: "Lamination Services" },
  { value: 636, label: "Land Clearing/ Grading" },
  { value: 637, label: "Landscaping" },
  { value: 638, label: "Landscaping, Lawn, Garden & Tree" },
  { value: 639, label: "Landscaping, Snowplowing & Firewood" },
  { value: 640, label: "Laser Vision Center" },
  { value: 641, label: "Laundromat" },
  { value: 642, label: "Laundry Services" },
  { value: 643, label: "Lawn Care" },
  { value: 644, label: "Lawyer" },
  { value: 645, label: "Learning Center" },
  { value: 646, label: "Leased On Trucker" },
  { value: 647, label: "Leasing Agent (Home)" },
  { value: 648, label: "Leasing And Rental Firm Companies" },
  { value: 649, label: "Lecturer" },
  { value: 650, label: "Legal Consultant" },
  { value: 651, label: "Lending Institution" },
  { value: 652, label: "Less than Truckload Carrier" },
  { value: 653, label: "Letter Delivery" },
  { value: 654, label: "Leveling" },
  { value: 655, label: "Library" },
  { value: 656, label: "Lie Detector Service" },
  { value: 657, label: "Lighting Technician/ Consultant" },
  { value: 658, label: "Limo (Airport)" },
  { value: 659, label: "Limousine" },
  { value: 660, label: "Linen Supply" },
  { value: 661, label: "Liquidation Store" },
  { value: 662, label: "Liquor Store" },
  { value: 663, label: "Livery" },
  { value: 664, label: "Livestock Farming/ Production" },
  { value: 665, label: "Livestock Hauling" },
  { value: 666, label: "Livestock Wholesaler" },
  { value: 667, label: "Loan Company" },
  { value: 668, label: "Local Cartage/ Trucking" },
  { value: 669, label: "Locksmith/ Key Duplicating Shop" },
  { value: 670, label: "Log Transport" },
  { value: 671, label: "Logging Trucker" },
  { value: 672, label: "Long Haul Trucking" },
  { value: 673, label: "Lounge" },
  { value: 674, label: "Lube/ Oil Service Center" },
  { value: 675, label: "Lumber Supply Store" },
  { value: 676, label: "Lumber Yard" },
  { value: 677, label: "Lumberjack" },
  { value: 678, label: "Lunch Truck/ Wagon" },
  { value: 679, label: "Lyft" },
  { value: 680, label: "Machinery & Heavy" },
  { value: 681, label: "Machinery Rental & Leasing" },
  { value: 682, label: "Magazine Company" },
  { value: 683, label: "Magazine Delivery" },
  { value: 684, label: "Magazine Stand" },
  { value: 685, label: "Magician" },
  { value: 686, label: "Maid" },
  { value: 687, label: "Mail Carrier" },
  { value: 688, label: "Mailing Service" },
  { value: 689, label: "Maintenance Person" },
  { value: 690, label: "Make Up Artist" },
  { value: 691, label: "Mall" },
  { value: 692, label: "Management Consulting" },
  { value: 693, label: "Managerial Firms/ Services" },
  { value: 694, label: "Manicurist" },
  { value: 695, label: "Manufacturer" },
  { value: 696, label: "Marble Work" },
  { value: 697, label: "Marina" },
  { value: 698, label: "Marine Supply (Retail)" },
  { value: 699, label: "Marine Supply Wholesaler" },
  { value: 700, label: "Market (Food)" },
  { value: 701, label: "Marketing Analyst" },
  { value: 702, label: "Marketing Consultant" },
  { value: 703, label: "Marketing Representative" },
  { value: 704, label: "Marriage Counselor" },
  { value: 705, label: "Martial Art Instructor" },
  { value: 706, label: "Mary Kay" },
  { value: 707, label: "Mason" },
  { value: 708, label: "Massage Therapist/ Massotherapies’" },
  { value: 709, label: "Masseur/ Masseuse" },
  { value: 710, label: "Mattress Retailer" },
  { value: 711, label: "Meals On Wheels" },
  { value: 712, label: "Meat Market" },
  { value: 713, label: "Meat Packing Plant" },
  { value: 714, label: "Mechanic" },
  { value: 715, label: "Mechanical Engineer" },
  { value: 716, label: "Media Consultant" },
  { value: 717, label: "Medical (Building/ Office/ Labs)" },
  { value: 718, label: "Medical Courier" },
  { value: 719, label: "Medical Equipment Wholesaler" },
  { value: 720, label: "Medical Transportation" },
  { value: 721, label: "Mental Health Services" },
  { value: 722, label: "Mental Work" },
  { value: 723, label: "Midwife" },
  { value: 724, label: "Mill Work (food/ Paper/ Materials)" },
  { value: 725, label: "Mill Work (Wood)" },
  { value: 726, label: "Mini Mart" },
  { value: 727, label: "Miniature Golf Course" },
  { value: 728, label: "Mining" },
  { value: 729, label: "Minister" },
  { value: 730, label: "Missionary" },
  { value: 731, label: "Mobile Billboard Owner" },
  { value: 732, label: "Mobile Detailers" },
  { value: 733, label: "Mobile Food Truck" },
  { value: 734, label: "Mobile Home Builder Or Repair" },
  { value: 735, label: "Mobile Home Manufacturing" },
  { value: 736, label: "Mobile Home Park" },
  { value: 737, label: "Mobile Home Sales" },
  { value: 738, label: "Mobile Home Toter" },
  { value: 739, label: "Mobile Mechanic" },
  { value: 740, label: "Model" },
  { value: 741, label: "Modeling Agency" },
  { value: 742, label: "Monastery" },
  { value: 743, label: "Money Transfer Services" },
  { value: 744, label: "Mortgage Broker" },
  { value: 745, label: "Mortgage Companies" },
  { value: 746, label: "Mosque" },
  { value: 747, label: "Motel" },
  { value: 748, label: "Motel Shuttle" },
  { value: 749, label: "Motion Picture Production" },
  { value: 750, label: "Motor Carrier" },
  { value: 751, label: "Motorcycle Dealership" },
  { value: 752, label: "Movers/ Moving Operation" },
  { value: 753, label: "Movie Theater" },
  { value: 754, label: "Mowing (Lawn)" },
  { value: 755, label: "Mud jacking Contractor" },
  { value: 756, label: "Muffler Repair/ Shop" },
  { value: 757, label: "Museum" },
  { value: 758, label: "Music Instruction" },
  { value: 759, label: "Music Store" },
  { value: 760, label: "Musical Group" },
  { value: 761, label: "Musician" },
  { value: 762, label: "Nail Salon" },
  { value: 763, label: "Mail Technician" },
  { value: 764, label: "Nanny" },
  { value: 765, label: "Nature Center" },
  { value: 766, label: "News Paper Company" },
  { value: 767, label: "News Stand" },
  { value: 768, label: "Newspaper Delivery" },
  { value: 769, label: "Night Watchmen/ Patrol" },
  { value: 770, label: "No Business" },
  { value: 771, label: "Non-Business" },
  { value: 772, label: "Non-Profit Organization" },
  { value: 773, label: "Non-Residential Contractor/ Developer" },
  { value: 774, label: "Non-Emergency Medical Transportation" },
  { value: 775, label: "Notary Public" },
  { value: 776, label: "Novelty Store" },
  { value: 777, label: "Nurse (Except Visiting Nurses)" },
  { value: 778, label: "Nurse (Visiting)" },
  { value: 779, label: "Nursery (flower/ Garden)" },
  { value: 780, label: "Nursery School" },
  { value: 781, label: "Nursing Home" },
  { value: 782, label: "OB Gyn" },
  { value: 783, label: "Obedience School (Animal)" },
  { value: 784, label: "Observatory" },
  { value: 785, label: "Obstetrician" },
  { value: 786, label: "Occupational Health Services" },
  { value: 787, label: "Occupational Therapist" },
  { value: 788, label: "Office Building" },
  { value: 789, label: "Office Cleaning" },
  { value: 790, label: "Office Equipment/ Supply Retail" },
  { value: 791, label: "Office Equipment/ Supply Wholesaler" },
  { value: 792, label: "Oil Change Service Center" },
  { value: 793, label: "Oilfield/ Well Service" },
  { value: 794, label: "Oilfield Equipment Haulers" },
  { value: 795, label: "Oilfield Materials Hauling" },
  { value: 796, label: "Optometrist" },
  { value: 797, label: "Orchard" },
  { value: 798, label: "Organ Transportation" },
  { value: 799, label: "Organic Food Store" },
  { value: 800, label: "Oriental Rug Dealer" },
  { value: 801, label: "Out Of State Contractor" },
  { value: 802, label: "Outreach Program" },
  { value: 803, label: "Over The Road Trucker" },
  { value: 804, label: "Oversized Load Hauling/ Trucking" },
  { value: 805, label: "Owner Operator" },
  { value: 806, label: "Package Delivery" },
  { value: 807, label: "Packaging Services" },
  { value: 808, label: "Packing Services" },
  { value: 809, label: "Pain Management" },
  { value: 810, label: "Paint Shop Automotive" },
  { value: 811, label: "Paint Store" },
  { value: 812, label: "Paint Wholesaler" },
  { value: 813, label: "Paintball Service" },
  { value: 814, label: "Painter (Artist)" },
  { value: 815, label: "Painter (House)" },
  { value: 816, label: "Painting (Contractor)" },
  { value: 817, label: "Pallet Distributor" },
  { value: 818, label: "Paper Mill" },
  { value: 819, label: "Paper Shredding" },
  { value: 820, label: "Paratransit" },
  { value: 821, label: "Park" },
  { value: 822, label: "Park (Amusement)" },
  { value: 823, label: "Park (Theme)" },
  { value: 824, label: "Park (Water)" },
  { value: 825, label: "Parking Garage/ Lot" },
  { value: 826, label: "Parking Lot Stripping" },
  { value: 827, label: "Parole Office/ Officer" },
  { value: 828, label: "Parts Wholesaler" },
  { value: 829, label: "Party Bus" },
  { value: 830, label: "Party Center" },
  { value: 831, label: "Party Planning Services" },
  { value: 832, label: "Party Supply Rental & Leasing" },
  { value: 833, label: "Party Supply Store" },
  { value: 834, label: "Passenger Transportation" },
  { value: 835, label: "Patent Attorney" },
  { value: 836, label: "Patio & Deck Builder" },
  { value: 837, label: "Petrolmen" },
  { value: 838, label: "Paving Contractor" },
  { value: 839, label: "Pawn Shop" },
  { value: 840, label: "Payroll Preparation" },
  { value: 841, label: "Pedicurist" },
  { value: 842, label: "Performance Artist" },
  { value: 843, label: "Personal Trainer" },
  { value: 844, label: "Personal Use Only" },
  { value: 845, label: "Personnel Services" },
  { value: 846, label: "Pest control" },
  { value: 847, label: "Pet Cemetery" },
  { value: 848, label: "Pet Groomer" },
  { value: 849, label: "Pet/ Pet Supply Store" },
  { value: 850, label: "Pharmaceutical Manufacturer" },
  { value: 851, label: "Pharmacy/ Pharmaceutical Sales" },
  { value: 852, label: "Photo Finishing" },
  { value: 853, label: "Photo Studio" },
  { value: 854, label: "Photocopy Services" },
  { value: 855, label: "Photographer" },
  { value: 856, label: "Physical Therapist" },
  { value: 857, label: "Physician" },
  { value: 858, label: "PI" },
  { value: 859, label: "Piano Mover" },
  { value: 860, label: "Piano mover" },
  { value: 861, label: "Piano Sales" },
  { value: 862, label: "Piano Tuning" },
  { value: 863, label: "Picture Framing" },
  { value: 864, label: "Pilot" },
  { value: 865, label: "Pipe Filter" },
  { value: 866, label: "Pipeline Installation (Public)" },
  { value: 867, label: "Pizza Delivery" },
  { value: 868, label: "Planetarium" },
  { value: 869, label: "Planner (Event)" },
  { value: 870, label: "Plastering Work" },
  { value: 871, label: "Plastic Manufacturing" },
  { value: 872, label: "Plating" },
  { value: 873, label: "Playground" },
  { value: 874, label: "Playground Equipment Sales" },
  { value: 875, label: "Plowing (Snow)" },
  { value: 876, label: "Plumbing" },
  { value: 877, label: "Politics" },
  { value: 878, label: "Polygraph Services" },
  { value: 879, label: "Pool Cleaner" },
  { value: 880, label: "Pool Hall" },
  { value: 881, label: "Pool Water Delivery" },
  { value: 882, label: "Pop-A-Lock" },
  { value: 883, label: "Popcorn Stand" },
  { value: 884, label: "Portrait Studios" },
  { value: 885, label: "Postman" },
  { value: 886, label: "Pottery Store/ Studio" },
  { value: 887, label: "Poultry Farmer" },
  { value: 888, label: "Poultry Hauling" },
  { value: 889, label: "Power Liner Installation (Public)" },
  { value: 890, label: "Prepared Food Truck" },
  { value: 891, label: "Preschool" },
  { value: 892, label: "Pressure Washing" },
  { value: 893, label: "Printing Company" },
  { value: 894, label: "Prisoner Transportation" },
  { value: 895, label: "Private Investigator" },
  { value: 896, label: "Produce Farmer" },
  { value: 897, label: "Product Market/ Stand" },
  { value: 898, label: "Professional Organization" },
  { value: 899, label: "Property maintenance" },
  { value: 900, label: "Property Management" },
  { value: 901, label: "Psychiatric Hospitals" },
  { value: 902, label: "Psychiatrist" },
  { value: 903, label: "Psychic" },
  { value: 904, label: "Psychologist" },
  { value: 905, label: "Pub" },
  { value: 906, label: "Public Accounting" },
  { value: 907, label: "Public Relations" },
  { value: 908, label: "Public Utility Installation" },
  { value: 909, label: "Publisher" },
  { value: 910, label: "Pulp Mill" },
  { value: 911, label: "Pulpwood Hauling" },
  { value: 912, label: "Pumper (Oil)" },
  { value: 913, label: "Quarry" },
  { value: 914, label: "Quarry Hauling" },
  { value: 915, label: "Race Car Driver" },
  { value: 916, label: "Race Track" },
  { value: 917, label: "Racquet Ball Club" },
  { value: 918, label: "Radiator Services" },
  { value: 919, label: "Radio Station" },
  { value: 920, label: "Ranching" },
  { value: 921, label: "Ranger (Forest)" },
  { value: 922, label: "Real Estate Agency" },
  { value: 923, label: "Realtor" },
  { value: 924, label: "Record Store" },
  { value: 925, label: "Recording Studio" },
  { value: 926, label: "Recreation Center" },
  { value: 927, label: "Recycling Services" },
  { value: 928, label: "Refinery Grain" },
  { value: 929, label: "Refrigerated Goods Hauling/ Trucking" },
  { value: 930, label: "Rehabilitation Center" },
  { value: 931, label: "Religious Organization" },
  { value: 932, label: "Remodeling" },
  { value: 933, label: "Removal (Animal)" },
  { value: 934, label: "Removal (Debris)" },
  { value: 935, label: "Removal (Garbage)" },
  { value: 936, label: "Renovations, Home" },
  { value: 937, label: "Rental & Leasing (Equipment)" },
  { value: 938, label: "Rental & Leasing (Housing/ Apartments)" },
  { value: 939, label: "Rental (Video)" },
  { value: 940, label: "Rental Office" },
  { value: 941, label: "Rental Property Management" },
  { value: 942, label: "Repair Services" },
  { value: 943, label: "Repair Services (Asphalt & Concrete)" },
  { value: 944, label: "Repair Services (Auto Body)" },
  { value: 945, label: "Repair Services (Auto Mechanical)" },
  { value: 946, label: "Repair Services (Heating & Air)" },
  { value: 947, label: "Repossession Work (Auto)" },
  { value: 948, label: "Research Organization" },
  { value: 949, label: "Residential Care" },
  { value: 950, label: "Residential Construction" },
  { value: 951, label: "Residential Contractor/ Developer" },
  { value: 952, label: "Restaurant" },
  { value: 953, label: "Restaurant With Delivery" },
  { value: 954, label: "Restoration (Art)" },
  { value: 955, label: "Restoration (Building)" },
  { value: 956, label: "Retirement Community" },
  { value: 957, label: "Ride Share" },
  { value: 958, label: "Riding Stable" },
  { value: 959, label: "Road Construction" },
  { value: 960, label: "Roadside Food Stand" },
  { value: 961, label: "Roadside Service/ Repair" },
  { value: 962, label: "Rock Band" },
  { value: 963, label: "Rock Hauling" },
  { value: 964, label: "Rock Quarry" },
  { value: 965, label: "Roofer" },
  { value: 966, label: "Roofing Contractor" },
  { value: 967, label: "Roustabout" },
  { value: 968, label: "Route Drivers" },
  { value: 969, label: "Rubbish Collection" },
  { value: 970, label: "Rug Cleaner" },
  { value: 971, label: "Rural Taxi" },
  { value: 972, label: "Rust Proofing" },
  { value: 973, label: "RV Park" },
  { value: 974, label: "RV Sales" },
  { value: 975, label: "Saddlery" },
  { value: 976, label: "Sales Representatives" },
  { value: 977, label: "Salon, Beauty" },
  { value: 978, label: "Saloon (Bar)" },
  { value: 979, label: "Salvage Work" },
  { value: 980, label: "Salvaged Auto Hauler" },
  { value: 981, label: "Sand & Gravel" },
  { value: 982, label: "Sand Hauler" },
  { value: 983, label: "Sandblasting" },
  { value: 984, label: "Sandwich Shop" },
  { value: 985, label: "Sanitation Services" },
  { value: 986, label: "Satellite Dish Installation" },
  { value: 987, label: "Savings & Loan" },
  { value: 988, label: "Savings Institution" },
  { value: 989, label: "Sawmill" },
  { value: 990, label: "School" },
  { value: 991, label: "Scouts" },
  { value: 992, label: "Scrap Metal/ Scrap Auto Hauler" },
  { value: 993, label: "Sculptor" },
  { value: 994, label: "Seamstress" },
  { value: 995, label: "Secretarial Services" },
  { value: 996, label: "Security Broker/ Dealer" },
  { value: 997, label: "Security Guard" },
  { value: 998, label: "Security Services" },
  { value: 999, label: "Security System Installation" },
  { value: 1000, label: "Senior Center" },
  { value: 1001, label: "Senior Citizens Transportation" },
  { value: 1002, label: "Septic Tank Installation" },
  { value: 1003, label: "Septic Waste Removal" },
  { value: 1004, label: "Service Station" },
  { value: 1005, label: "Sewer Cleaner" },
  { value: 1006, label: "Sewer Line Installation (Public)" },
  { value: 1007, label: "Sheet Metal Contractor/ Repairman" },
  { value: 1008, label: "Shelter" },
  { value: 1009, label: "Shipping Services" },
  { value: 1010, label: "Shoe Repair" },
  { value: 1011, label: "Shoe Store" },
  { value: 1012, label: "Shopping Center/ Mall" },
  { value: 1013, label: "Shredding Services" },
  { value: 1014, label: "Shrine" },
  { value: 1015, label: "Sidewalk Installation (Private)" },
  { value: 1016, label: "Sidewalk Installation (Public)" },
  { value: 1017, label: "Siding Installation/ Repair" },
  { value: 1018, label: "Sightseeing Tours" },
  { value: 1019, label: "Sign Company" },
  { value: 1020, label: "Singer" },
  { value: 1021, label: "Singing Telegram" },
  { value: 1022, label: "Skateboard Park" },
  { value: 1023, label: "Skating Rink" },
  { value: 1024, label: "Ski Instructor" },
  { value: 1025, label: "Ski Resort" },
  { value: 1026, label: "Slab Work (Concrete/ Asphalt)" },
  { value: 1027, label: "Snow Removal" },
  { value: 1028, label: "Snowmobile Dealer" },
  { value: 1029, label: "Snowplowing" },
  { value: 1030, label: "Social Services" },
  { value: 1031, label: "Social Worker" },
  { value: 1032, label: "Soil Preparation Services" },
  { value: 1033, label: "Souvenir Shop" },
  { value: 1034, label: "Spa" },
  { value: 1035, label: "Specialty Food Store" },
  { value: 1036, label: "Speech Pathologist" },
  { value: 1037, label: "Sporting Goods Store" },
  { value: 1038, label: "Sports Arena" },
  { value: 1039, label: "Sports Bar" },
  { value: 1040, label: "Sports Medicine" },
  { value: 1041, label: "Spot Welding" },
  { value: 1042, label: "Sprinkler Installation" },
  { value: 1043, label: "Stables (Horse)" },
  { value: 1044, label: "Stadium" },
  { value: 1045, label: "Stage Performer" },
  { value: 1046, label: "Steam Cleaning" },
  { value: 1047, label: "Steel Hauling" },
  { value: 1048, label: "Stenographer" },
  { value: 1049, label: "Stockbroker" },
  { value: 1050, label: "Stonework" },
  { value: 1051, label: "Storage Facility" },
  { value: 1052, label: "Store" },
  { value: 1053, label: "Street Construction" },
  { value: 1054, label: "Street Sweeper" },
  { value: 1055, label: "Stylist (Hair)" },
  { value: 1056, label: "Sub Shop" },
  { value: 1057, label: "Sub Truck" },
  { value: 1058, label: "Supermarket" },
  { value: 1059, label: "Support Group" },
  { value: 1060, label: "Surveying Services" },
  { value: 1061, label: "Surveyor (Construction)" },
  { value: 1062, label: "Sweeping Services" },
  { value: 1063, label: "Swimming Instruction" },
  { value: 1064, label: "Swimming Pool Cleaning" },
  { value: 1065, label: "Synagogue" },
  { value: 1066, label: "System Analyst" },
  { value: 1067, label: "Table & Chair Rental" },
  { value: 1068, label: "Tailor" },
  { value: 1069, label: "Talent Agent" },
  { value: 1070, label: "Tanning Salon" },
  { value: 1071, label: "Tattoo Artist" },
  { value: 1072, label: "Tavern" },
  { value: 1073, label: "Tax Preparer" },
  { value: 1074, label: "Taxi Non-Emergency Medical Transportation" },
  { value: 1075, label: "Taxi (Airport)" },
  { value: 1076, label: "Taxi (Amish)" },
  { value: 1077, label: "Taxi (Rural)" },
  { value: 1078, label: "Taxi Service" },
  { value: 1079, label: "Taxidermist" },
  { value: 1080, label: "Teacher" },
  { value: 1081, label: "Telemarketing Company" },
  { value: 1082, label: "Telephone Answering Service" },
  { value: 1083, label: "Telephone line Installation (Public)" },
  { value: 1084, label: "Television Station" },
  { value: 1085, label: "Temp Agency/ Services" },
  { value: 1086, label: "Temple" },
  { value: 1087, label: "Tennis Court" },
  { value: 1088, label: "Tent Rental" },
  { value: 1089, label: "Tent Repair" },
  { value: 1090, label: "Termite Control" },
  { value: 1091, label: "Textile Mill" },
  { value: 1092, label: "Theater" },
  { value: 1093, label: "Theme Park" },
  { value: 1094, label: "Thrift Store" },
  { value: 1095, label: "Ticket Sales" },
  { value: 1096, label: "Tile Installation/ Repair" },
  { value: 1097, label: "Timber Cruisers" },
  { value: 1098, label: "Tinting Services Auto" },
  { value: 1099, label: "Tire Manufacturing" },
  { value: 1100, label: "Tire Repair and Re-Treading" },
  { value: 1101, label: "Tire Sales (Retail)" },
  { value: 1102, label: "Tire Wholesaler" },
  { value: 1103, label: "Title Agent" },
  { value: 1104, label: "Title Company" },
  { value: 1105, label: "Tobacco Manufacturing" },
  { value: 1106, label: "Tobacco Store" },
  { value: 1107, label: "Tool Maker" },
  { value: 1108, label: "Tool Rental & Leasing Company" },
  { value: 1109, label: "Towing" },
  { value: 1110, label: "Toy Manufacturing" },
  { value: 1111, label: "Toy Store" },
  { value: 1112, label: "Trailer Park" },
  { value: 1113, label: "Translator" },
  { value: 1114, label: "Transmission Repair Shop" },
  { value: 1115, label: "Transport Passengers" },
  { value: 1116, label: "Transportation (Cargo)" },
  { value: 1117, label: "Transportation For the Elderly Person" },
  { value: 1118, label: "Trapper" },
  { value: 1119, label: "Trash Removal" },
  { value: 1120, label: "Travel Agency/ Agent" },
  { value: 1121, label: "Tree Service" },
  { value: 1122, label: "Trophy Shop" },
  { value: 1123, label: "Tropical Fish Store" },
  { value: 1124, label: "Truck Dealer/ Sales" },
  { value: 1125, label: "Trucker" },
  { value: 1126, label: "Fracking Sand Trucking" },
  { value: 1127, label: "Fracking Water (Fresh or Production) Trucking" },
  { value: 1128, label: "Oilfield Materials Trucking" },
  { value: 1129, label: "Trust Company" },
  { value: 1130, label: "Truck Pointing Contractor" },
  { value: 1131, label: "Tune Up Services" },
  { value: 1132, label: "Tunnel Construction" },
  { value: 1133, label: "Tupperware Sales" },
  { value: 1134, label: "Tutor" },
  { value: 1135, label: "Tuxedo Rental" },
  { value: 1136, label: "Uber" },
  { value: 1137, label: "Ultrasound services" },
  { value: 1138, label: "Ultrasound Technician" },
  { value: 1139, label: "Uniform Supply Services" },
  { value: 1140, label: "University" },
  { value: 1141, label: "Upholstery Cleaning" },
  { value: 1142, label: "Upholstery Repair" },
  { value: 1143, label: "Urban Development" },
  { value: 1144, label: "Urgent Care" },
  { value: 1145, label: "Used Book Store" },
  { value: 1146, label: "Used Car Dealer" },
  { value: 1147, label: "Used Merchandise Store" },
  { value: 1148, label: "Utility Installation" },
  { value: 1149, label: "Vegetable Stand" },
  { value: 1150, label: "Vehicle Hauler" },
  { value: 1151, label: "Vending Machine Supplier/ Operator" },
  { value: 1152, label: "Vendor" },
  { value: 1153, label: "Ventilation Services" },
  { value: 1154, label: "Veterinarian" },
  { value: 1155, label: "Video Game Store" },
  { value: 1156, label: "Videographer" },
  { value: 1157, label: "Video Rental/ Sales" },
  { value: 1158, label: "Video Taping Services" },
  { value: 1159, label: "Vineyard" },
  { value: 1160, label: "Vintage Clothing Store" },
  { value: 1161, label: "Visiting Nurse" },
  { value: 1162, label: "Visitor Center" },
  { value: 1163, label: "Vitamin Store" },
  { value: 1164, label: "Vocational School" },
  { value: 1165, label: "Volunteer Organization" },
  { value: 1166, label: "Wallpaper Hanger" },
  { value: 1167, label: "Washing Machine Repair" },
  { value: 1168, label: "Watch Repair" },
  { value: 1169, label: "Water Line Installation (Public)" },
  { value: 1170, label: "Water Park" },
  { value: 1171, label: "Water Well Drilling" },
  { value: 1172, label: "Waterproofing" },
  { value: 1173, label: "Wedding Planner" },
  { value: 1174, label: "Weight Loss Center" },
  { value: 1175, label: "Welder" },
  { value: 1176, label: "Welfare Office" },
  { value: 1177, label: "Well Drilling (Water)" },
  { value: 1178, label: "White Water Rafting Tour" },
  { value: 1179, label: "Wholesale Route Drivers" },
  { value: 1180, label: "Wholesale Trade" },
  { value: 1181, label: "Wide Load Hauler" },
  { value: 1182, label: "Window Cleaner" },
  { value: 1183, label: "Window Installation/ Repair" },
  { value: 1184, label: "Window Repair (Auto)" },
  { value: 1185, label: "Window Tinting" },
  { value: 1186, label: "Winery" },
  { value: 1187, label: "Wood Chip Hauling" },
  { value: 1188, label: "Wood Worker" },
  { value: 1189, label: "Wrecker Service" },
  { value: 1190, label: "Wrecking Crew (Demolition)" },
  { value: 1191, label: "Writer" },
  { value: 1192, label: "X-Ray Lab" },
  { value: 1193, label: "X-Ray Technician" },
  { value: 1194, label: "Yacht Charter" },
  { value: 1195, label: "Yard Equipment Rental & Leasing Company" },
  { value: 1196, label: "Yoga Instructor" },
  { value: 1197, label: "Youth Center" },
  { value: 1198, label: "Zoo/ Zoological Garden" },
];

// export function formatTime(isoDateString) {
//   const date = new Date(isoDateString);

//   // Get hours and minutes
//   let hours = date.getHours();
//   const minutes = date.getMinutes();
//   const ampm = hours >= 12 ? "PM" : "AM";

//   // Convert 24-hour time to 12-hour time
//   hours = hours % 12 || 12; // Adjust 0 to 12 for 12-hour format

//   // Format minutes with leading zero
//   const formattedMinutes = minutes.toString().padStart(2, "0");

//   // Combine hours, minutes, and AM/PM
//   return `${hours}:${formattedMinutes}${ampm}`;
// }

export function formatTime(isoDateString) {
  const date = new Date(isoDateString);

  // Get the date components
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" }); // Short month name (e.g., Jan, Feb)
  const year = date.getFullYear();

  // Get hours and minutes
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert 24-hour time to 12-hour time
  hours = hours % 12 || 12; // Adjust 0 to 12 for 12-hour format

  // Format minutes with leading zero
  const formattedMinutes = minutes.toString().padStart(2, "0");

  // Combine date, time, and AM/PM
  return `${day} ${month} ${year}, ${hours}:${formattedMinutes} ${ampm}`;
}

export function formatTimeToAMPM(time) {
  // Split the time string into hours, minutes, and seconds
  let [hours, minutes] = time.split(":");

  // Convert hours to a number
  hours = parseInt(hours);

  // Determine AM or PM
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert hours to 12-hour format
  hours = hours % 12 || 12;

  // Return formatted time
  return `${hours}:${minutes} ${ampm}`;
}
export function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distance = R * c;
  return distance.toFixed(2);
}

export const truncateString = (str, maxLength) => {
  return str.length > maxLength ? str.slice(0, maxLength) + "..." : str;
};

export const errorHandler = (error) => {
  if (!Array.isArray(error)) {
    Object.values(error).map((errorMessage) => {
      toast.error(errorMessage[0]);
    });
  } else {
    error.map((errorMessage) => {
      toast.error(errorMessage[0]);
    });
  }
};

export const showDesktopNotification = (title, message) => {
  if (Notification.permission === "granted") {
    const notification = new Notification(title, { body: message });

    // notification.onclick = () => {
    //   window.location.href = "https://isit.theremotepad.com/employee/notifications"
    // };
  } else {
    console.log("Notification permission not granted.");
  }
};

export const countRating = (request) => {
  let number = 0;
  let totalStars = 0;
  let average = 0;

  for (let i = 0; i < request.length; i++) {
    number++;
    totalStars = totalStars + request[i]?.feedback?.stars;
  }

  average = totalStars / number;

  return average;
};

export const centsToDollar = (cents) => {
  const priceInDollars = (cents / 100).toFixed(2);
  return priceInDollars;
};
